// Könnyűsúlyú látogatáskövető modul (saját backend, nincs külső szolgáltatás)
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getSessionId = () => {
  let sid = sessionStorage.getItem("nia_session_id");
  if (!sid) {
    sid = `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem("nia_session_id", sid);
  }
  return sid;
};

const isAdminPath = () => window.location.pathname.startsWith("/admin");

export const track = (event_type, extra = {}) => {
  if (isAdminPath()) return;
  const payload = {
    session_id: getSessionId(),
    event_type,
    path: window.location.pathname,
    screen: `${window.innerWidth}x${window.innerHeight}`,
    ...extra,
  };
  try {
    axios.post(`${API}/analytics/track`, payload).catch(() => {});
  } catch {
    /* csendes hiba */
  }
};

export const trackPageview = (path) => {
  if (isAdminPath()) return;
  track("pageview", { path, referrer: document.referrer || "" });
};

let heartbeatTimer = null;
let clickListenerAdded = false;

export const initAnalytics = () => {
  // Szívverés 20 mp-enként, amíg a fül aktív – ebből számolódik az oldalon töltött idő
  if (!heartbeatTimer) {
    heartbeatTimer = setInterval(() => {
      if (document.visibilityState === "visible") track("heartbeat");
    }, 20000);
  }

  // Globális kattintás követés: gombok és linkek felirata
  if (!clickListenerAdded) {
    clickListenerAdded = true;
    document.addEventListener(
      "click",
      (e) => {
        const el = e.target.closest("a, button");
        if (!el || isAdminPath()) return;
        const label = (el.getAttribute("aria-label") || el.textContent || "")
          .trim()
          .replace(/\s+/g, " ")
          .slice(0, 50);
        if (label) track("click", { label });
      },
      { capture: true, passive: true }
    );
  }
};
